import React from 'react';
import ClickableHelpIcon from 'components/pure/utils/ClickableHelpIcon';
import ProgressMarkerIcon from 'components/pure/utils/icon/ProgressMarkerIcon';
import ToggleField from 'components/pure/utils/form/ToggleField';
import Theme from 'styles/theme';
import classNames from 'classnames';
import './RepProfileSectionHeader.styl';
import BasedOnDatesLink from 'components/dashboard/common/BasedOnDatesLink';

const toggleStyles = {
  thumb: {backgroundColor: Theme.palette.lynch},
  track: {
    backgroundColor: Theme.palette.lynch,
    opacity: 0.5,
  },
};

export default class RepProfileSectionHeader extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.state = {};
  }

  onMouseEnter() {
    this.setState({hovered: true});
  }

  onMouseLeave() {
    this.setState({hovered: false});
  }

  render() {
    const {toggled = false, title, showTeamIcon = true} = this.props;
    const showToggle = this.props.showToggle !== false && this.props.toggledLabel;
    return (
      <div className="rep-profile-section-header-and-dates">
        <div
          className={classNames('row header-row rep-profile-section-header', {
            'toggle-shown': showToggle,
          })}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}>
          <div className="header-column">
            <div className="title-text header-item">{title}</div>
            {showTeamIcon && (
              <div className="team-legend header-item">
                <span>Team Average</span>
                <ProgressMarkerIcon />
              </div>
            )}
          </div>
          {showToggle && (
            <div className="header-item toggle-switch">
              <ToggleField
                label={toggled ? this.props.toggledLabel : this.props.unToggledLabel}
                thumbStyle={toggleStyles.thumb}
                trackStyle={toggleStyles.track}
                thumbSwitchedStyle={toggleStyles.thumb}
                trackSwitchedStyle={toggleStyles.track}
                labelPosition="right"
                value={this.props.toggled}
                onChange={this.props.handleToggle}
                disabled={this.props.isToggleDisabled}
              />
              {this.state.hovered && this.props.helpText && (
                <ClickableHelpIcon text={this.props.helpText} />
              )}
            </div>
          )}
        </div>
        <BasedOnDatesLink
          className={showToggle ? 'with-toggle' : showTeamIcon ? 'with-team' : ''}
          {...this.props}
        />
      </div>
    );
  }
}
